<template>
  <div class="uploaded-files" v-if="files && files.length">
    <ModalConfirm :showMe="showMe" @confirmed="modalResponse" />
    <p>Uploaded files</p>
    <ul>
      <li v-for="file in files" :key="file.name">
        <a :href="file.downloadURL" target="_blank">{{ file.originalFilename }}</a>
        <span class="delete-file">
          <i class="fas fa-trash-alt" @click="trashFile(file)"></i>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import firebase from "firebase/app";
// eslint-disable-next-line
import storage from "firebase/storage";

import ModalConfirm from "@/components/ModalConfirm";

export default {
  name: "UploadedFiles",
  components: {
    ModalConfirm
  },
  props: ["files"],
  data() {
    return {
      showMe: false,
      fileToDelete: null
    };
  },
  methods: {
    trashFile(file) {
      this.fileToDelete = file;
      this.showMe = true;
    },
    modalResponse(response) {
      if (response) {
        this.deleteFile();
      }
      this.showMe = false;
      this.fileToDelete = null;
    },
    deleteFile() {
      const file = Object.assign({}, this.fileToDelete);
      const storageRef = firebase.storage().ref();
      const fileRef = storageRef.child(
        "/board_files/" + this.fileToDelete.name
      );
      fileRef
        .delete()
        .then(() => {
          this.$emit("fileDeleted", file);
        })
        .catch(err => window.console.log("Error deleting: ", err))
        .then(() => (this.fileToDelete = null));
    }
  }
};
</script>

<style lang="scss">
.uploaded-files {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  border: solid 1px #eee;
  margin-top: 0.5rem;
  padding: 0 1rem 1rem;
  p {
    text-align: center;
    font-weight: bolder;
  }
  ul {
    li {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      max-width: 315px;
      span.delete-file {
        text-align: center;
        min-width: 2rem;
        cursor: pointer;
      } // span.delete-file
    } // li
  } //ul
} // .uploaded-files
</style>
